module.exports = __webpack_public_path__ + "static/media/comment-alt-redo.758b73f0.svg";